import { useFormStore } from '@/stores/form'
import apiHelperService from '@/services'
import { notify } from 'notiwind'
import i18n from '@/i18n/i18n'
import { useGlobalStore } from '@/stores/global'
import client_lookups from '@/assets/json/clientLookups.json'

const doNotify = (title, text, duration = 6000, group = 'error') => {
  notify(
    {
      group: group,
      title,
      text
    },
    duration
  )
}

const getInitialApprovalRequestInfo = async (requestNumber) => {
  const res = await apiHelperService.get(
    `/api/individual/establishmentCard/getInitialApprovalRequest/${requestNumber}`
  )
  if (res) {
    const {
      englishEstablishmentName,
      arabicEstablishmentName,
      investorUnifiedNumber,
      investorPhoneNumber,
      economicActivityId
    } = res

    formStore.form.setValues({
      englishEstablishmentName,
      arabicEstablishmentName,
      investorUnifiedNumber,
      investorPhoneNumber,
      economicActivityId
    })
  }
}

const checkInistialApprovalRequest = async ({ disableField } = actionParams) => {
  const formStore = useFormStore()
  const { referenceRequestNumber, immigrationDepartmentId } = formStore.form.values || {}

  if (!referenceRequestNumber) {
    return
  }

  if (!immigrationDepartmentId) {
    doNotify(
      i18n.global.t('pleaseEnterImmigrationDepartment'),
      i18n.global.t('pleaseEnterImmigrationDepartment')
    )
    return
  }

  let data = {
    requestNumber: referenceRequestNumber,
    administrativeRegionId: formStore.extraMap.administrativeRegionId
  }

  try {
    const result = await apiHelperService.post(
      `/api/individual/establishmentCard/checkEstabInitialApproval`,
      data
    )
    if (!result || (result && !result.checkApprovalFlag)) {
      formStore.form.setFieldValue('referenceRequestNumber', '')
      doNotify(i18n.global.t('initialApprovalNotExist'), i18n.global.t('initialApprovalNotExist'))
      return
    }

    getInitialApprovalRequestInfo(referenceRequestNumber)
  } catch (error) {
    formStore.form.setFieldValue('referenceRequestNumber', '')
    console.error('checkInistialApprovalRequest', error)
  }
}

const getAvailableInitialApprovalRequests = async () => {
  const res = await apiHelperService.get(
    '/api/individual/establishmentCard/getAvailableInitialApprovalRequests'
  )
}

function filterWorkSector(options) {
  const globalStore = useGlobalStore()
  const { serviceTransactionId } = globalStore.startedService
  const {
    workSectors: {
      federalGovernment,
      localDepartment,
      governmentEstablishment,
      semiGovernmentEstablishment
    }
  } = client_lookups
  if (serviceTransactionId == 139) {
    return options.filter((item) =>
      [
        federalGovernment,
        localDepartment,
        governmentEstablishment,
        semiGovernmentEstablishment
      ].includes(item.id)
    )
  } else if (serviceTransactionId == 140) {
    return options.filter(
      (item) =>
        ![
          federalGovernment,
          localDepartment,
          governmentEstablishment,
          semiGovernmentEstablishment
        ].includes(item.id)
    )
  }
  return options
}

function filterEstablishmentType(options) {
  const globalStore = useGlobalStore()
  const { serviceTransactionId } = globalStore.startedService
  const {
    governmentEstablishment: { emirateGovernment, fedralGovernment, semiGovernment }
  } = client_lookups
  if (serviceTransactionId == 140) {
    return options.filter(
      (item) => ![emirateGovernment, fedralGovernment, semiGovernment].includes(item.id)
    )
  }
  return options
}

async function currentNationalityChange() {
  const formStore = useFormStore()
  const {
    applicantUnifiedNumber = '',
    applicantNationalityId = '',
    applicantDateOfBirth = ''
  } = formStore.form.values || {}

  if (applicantUnifiedNumber && applicantNationalityId && applicantDateOfBirth) {
    function resetData() {
      formStore.form.setValues({
        applicantUnifiedNumber: '',
        englishApplicantName: '',
        arabicApplicantName: '',
        applicantIdentityNumber: '',
        applicantNationalityId: '',
        applicantDateOfBirth: ''
      })
    }
    try {
      const result = await apiHelperService.get(
        '/api/establishment/establismentCard/is-applicant-visaHolder',
        {
          params: {
            personUnifiedNumber: applicantUnifiedNumber,
            nationalityId: applicantNationalityId,
            dateOfBirth: applicantDateOfBirth
          }
        }
      )

      if (!result) {
        resetData()
        return
      }

      const {
        isVisaHolder = false,
        wrongApplicantInfo = false,
        englishApplicantName = '',
        arabicApplicantName = '',
        applicantIdentityNumber = ''
      } = result
      if (!isVisaHolder) {
        doNotify(
          i18n.global.t('warningTitle'),
          i18n.global.t('youShouldUseTheEmiratesIDCardReader')
        )
        resetData()
        return
      } else if (wrongApplicantInfo) {
        doNotify(
          i18n.global.t('warningTitle'),
          i18n.global.t('sorryTheEteredApplicantInformationIsWrong')
        )
        resetData()
      } else {
        formStore.draft.request = {
          ...formStore.draft.request,
          englishApplicantName: englishApplicantName,
          arabicApplicantName: arabicApplicantName,
          applicantIdentityNumber: applicantIdentityNumber
        }
      }
    } catch (error) {
      console.error('currentNationalityChange', error)
    }
  }
}
export default function (actionName, actionParams) {
  switch (actionName) {
    case 'checkInistialApprovalRequest':
      checkInistialApprovalRequest(actionParams)
      break
    case 'getIndivInfoByIdnNumOrUnNumForChildsFamily':
      getIndivInfoByIdnNumOrUnNumForChildsFamily(actionParams)
    case 'getAvailableInitialApprovalRequests':
      getAvailableInitialApprovalRequests(actionParams)
      break
    case 'filterWorkSector':
      return filterWorkSector(actionParams)
    case 'filterEstablishmentType':
      return filterEstablishmentType(actionParams)
    case 'currentNationalityChange':
      currentNationalityChange(actionParams)
    default:
      break
  }
}
